
import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    Menu,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableSortLabel,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Button,
    Dialog,
    Slide,
    TextField
} from "@mui/material";
import {ContainerClasses} from '../../../themes/containerClasses';
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import {useTheme} from '@mui/material/styles';
import {ListViewModel,
        ListViewColumnModel,
        RecordModel} from '../../../models/models';
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {SearchFieldComponent} from "../../../components/searchField/SearchField";
import {useSnackbar} from "notistack";
import { formatDate, formatDatetime } from "../../../utils/dateFunctions";
import {Link, useParams} from 'react-router-dom';
import {getAppName, getObjectName } from "../../../utils/helperRouter";
import Config from "../../../config";
import { useAuth } from "../../../hooks/useAuth";


export const AsyncTaskInformationComponent: React.FC<{
  data: any
}> = ({
  data
}) => {

  const styles = ContainerClasses();

  let {appName, objectName, recordUuid} = useParams();

  const { enqueueSnackbar } = useSnackbar();

  const [thisData, setThisData] = useState<any>({});


  useEffect(() => {
    if(data){
      setThisData(data)
    }
  }, [data]); // eslint-disable-line react-hooks/exhaustive-deps


  return (
    <Box sx={{height: '100%'}}>
      {
        thisData.status &&
        <Box sx={{display: 'flex',
                  flexDirection: 'row',
                  gap: '0.4rem'}}>
          <Typography variant='body2' sx={{fontWeight: 600}}> Status: </Typography>
          <Typography variant='body2'> {thisData.status} </Typography>
        </Box>
      }
      {
        thisData.result &&
        <Box sx={{display: 'flex',
                  flexDirection: 'row',
                  gap: '0.4rem'}}>
          <Typography variant='body2' sx={{fontWeight: 600}}> Result: </Typography>
          <Typography variant='body2'> {JSON.stringify(thisData.result, null, 2)} </Typography>
        </Box>
      }
      {
        thisData?.traceback &&
        <Box sx={{display: 'flex',
                  flexDirection: 'row',
                  gap: '0.4rem'}}>
          <Typography variant='body2' sx={{fontWeight: 600}}> Status: </Typography>
          <Typography variant='body2'> {thisData.traceback} </Typography>
        </Box>
      }
    </Box>
  );

};
